<div [formGroup]="subForm">
  <div class="mt-3">
    <!--@if ((authService.isAdmin() | async) ) {-->
    <span *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog"
      for="label"><strong>{{variables.addChangeRemoveSubTask}}.</strong></span>
    <!--}-->
    <!--@if (!((authService.isAdmin() | async) )) {-->
    <span *hasPermission="Permission.CATALOG_EDIT_CONFIG "
      [showWhen]="!canEditCatalog"><strong>{{variables.catalogTasks}}</strong></span>
    <!--}-->

    @if (listSubTasks?.length > 0) {
    <div class="list-group-control">
      <div class="d-flex list-group-control-header header-sticky">
        <div class="list-group-control-header-name">{{variables.name}}</div>
      </div>
      <div cdkScrollable>
        <div cdkDropList (cdkDropListDropped)="dropTable($event)">
          @for (item of listSubTasks; track item) {
          <div class="list-group-control-item" cdkDrag>
            <div class="list-group-control-item-name">{{item.name}}</div>
            <div class="list-group-control-item-icons action_buttons">
              <span *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog"
                matTooltip="{{variables.changeSubTask}}" (click)="openDialogEditProject(item)"
                class="icon-edit me-3 action_buttons-item">
                <img src="../../../../assets/svg/EditWhite.svg" alt="Edit Icon" width="20px">
              </span>
              <span *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog"
                matTooltip="{{variables.removeSubTask}}" (click)="openDialogRemove(item.name)"
                class="icon-close me-1 action_buttons-item">
                <img src="../../../../assets/svg/BinWhite.svg" alt="Bin Icon" width="15px">
              </span>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
    }
    <br>
    <div class="mt-3"></div>
    <!--@if ((authService.isAdmin() | async) ) {-->
    <app-button *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog" typeBtn="primary"
      class="addItemsInCatalogStepBtn" (click)="openDialogProject()" message="{{variables.addSubTask}}"></app-button>
    <!--}-->
  </div>
</div>